module.exports = "pegasus_template/assets/social-profile-preview-old.png";